import React from 'react';
import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/listbox/listbox.module.css';

interface ListBoxEmptyStateProps {
  children?: React.ReactNode;
}

export const ListBoxEmptyState: React.FC<ListBoxEmptyStateProps> = ({
  children,
}) => (
  <div
    className={clsx(
      styles['sapphire-listbox__item'],
      styles['sapphire-listbox__item--empty']
    )}
  >
    <div className={clsx(styles['sapphire-listbox__content'])}>
      <div
        role="presentation"
        className={styles['sapphire-listbox__primary-text']}
      >
        {children}
      </div>
    </div>
  </div>
);
